import api from "./api";

const VAULT_BASE_PATH = "/vault/entries";
const VAULT_CATEGORIES_BASE_PATH = "/vault/categories";

const toVaultEntryPayload = (entry = {}) => {
  const payload = {
    siteName: String(entry?.siteName ?? "").trim(),
    websiteUrl: String(entry?.websiteUrl ?? "").trim(),
    username: String(entry?.username ?? "").trim(),
    categoryId: String(entry?.categoryId ?? "").trim(),
    notes: String(entry?.notes ?? "").trim(),
  };

  const password = String(entry?.password ?? "");
  if (password) {
    payload.password = password;
  }
  return payload;
};

const toVaultCategoryPayload = (categoryPayload = {}) => ({
  name: String(categoryPayload?.name ?? "").trim(),
});

const normalizeEntriesResponse = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.entries)) return payload.entries;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

const normalizeCategoriesResponse = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.categories)) return payload.categories;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

const normalizePermissionsResponse = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.permissions)) return payload.permissions;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

export async function listVaultEntries(params = {}) {
  const response = await api.get(VAULT_BASE_PATH, { params });
  return normalizeEntriesResponse(response.data);
}

export async function createVaultEntry(entry) {
  const response = await api.post(VAULT_BASE_PATH, toVaultEntryPayload(entry));
  return response.data;
}

export async function updateVaultEntry(entryId, entry) {
  const response = await api.put(
    `${VAULT_BASE_PATH}/${entryId}`,
    toVaultEntryPayload(entry)
  );
  return response.data;
}

export async function deleteVaultEntry(entryId) {
  const response = await api.delete(`${VAULT_BASE_PATH}/${entryId}`);
  return response.data;
}

export async function revealVaultPassword(entryId) {
  const response = await api.post(`${VAULT_BASE_PATH}/${entryId}/reveal`);
  return response.data?.password || "";
}

export async function listVaultCategories() {
  const response = await api.get(VAULT_CATEGORIES_BASE_PATH);
  return normalizeCategoriesResponse(response.data);
}

export async function createVaultCategory(categoryPayload) {
  const response = await api.post(
    VAULT_CATEGORIES_BASE_PATH,
    toVaultCategoryPayload(categoryPayload)
  );
  return response.data;
}

export async function updateVaultCategory(categoryId, categoryPayload) {
  const response = await api.put(
    `${VAULT_CATEGORIES_BASE_PATH}/${categoryId}`,
    toVaultCategoryPayload(categoryPayload)
  );
  return response.data;
}

export async function deleteVaultCategory(categoryId) {
  const response = await api.delete(`${VAULT_CATEGORIES_BASE_PATH}/${categoryId}`);
  return response.data;
}

export async function listVaultCategoryPermissions(categoryId) {
  const response = await api.get(
    `${VAULT_CATEGORIES_BASE_PATH}/${categoryId}/permissions`
  );
  return normalizePermissionsResponse(response.data);
}

export async function updateVaultCategoryPermission(
  categoryId,
  employeeId,
  enabled
) {
  const response = await api.put(
    `${VAULT_CATEGORIES_BASE_PATH}/${categoryId}/permissions/${employeeId}`,
    { enabled: Boolean(enabled) }
  );
  return response.data;
}
